import { CourseToolsMixin } from '@/courses/mixins/course-tools.mixin';
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { Section } from '@/courses/models/section.model';
import Course from '@/content/models/course.model';
import { COURSE_EVENTS } from '@/content/values/events';
import { PRESENTATION_MODE_EVENTS } from '@/content/values/ed-presentation-mode.values';

@Component({
  components: {
    EdDeckViewer: () => import(/* EdDeckViewer */'../ed-deck-viewer/ed-deck-viewer.component.vue')
  }
})
export default class EdSubdeckViewerComponent extends Mixins(CourseToolsMixin) {
  @Prop() readonly section: Section;
  @Prop() readonly courseId: number;
  @Prop({default: null}) readonly classId: number;

  public deck: Section = new Section({});
  public cards: Section[] = [];
  public userView = '';

  get hasCards(): boolean {
    if (this.cards.length > 0) {
      return !!this.cards[0]?.id;
    }

    return false;
  }

  get course(): Course {
    return this.getCourseFromStore({courseId: this.courseId , classId: this.classId });
  }

  get currentCardInfo() {
    return this.$store.state.CourseStore.currentCardInfo;
  }

  get isPresentationTeacherMode() {
    return this.$store.state.CourseStore.isPresentationTeacherMode;
  }

  get isPresentationMode() {
    return this.$store.state.CourseStore.isPresentationTeacherMode || this.$store.state.CourseStore.isPresentationStudentMode;
  }

  initSubdeck(){
    const data =  JSON.parse(this.section.text);

    this.userView = data.userView;
    this.deck = this.course.deckLibrary.sections.find(s => {
      return s.sectionId === data.deck;
    });

    let currentCards = new Set(data.cards);

    this.cards = [];

    this.deck.sections.forEach((card) => {
      if (currentCards.has(card.id)) {
        this.cards.push(card);
      }
    });

    this.shuffleCards()
  }

  shuffleCards(){
    if(this.userView === 'RANDOM') {
      this.cards = this.cards.sort(() => Math.random() - 0.5);
    }
  }
  created() {
    if (this.course) {
      this.initSubdeck();
    }

    this.$edEventBus.$emit(PRESENTATION_MODE_EVENTS.LOAD_PRESENTATION_ELEMENTS);
    this.$edEventBus.$on(COURSE_EVENTS.CHANGE_CARD_SIDE, this.resetCards);
  }

  mounted() {
    if(this.course) {
      this.initSubdeck();
    } else {
      this.cards = [];
      this.cards.push(this.currentCardInfo.card)
      this.deck = new Section({});
    }
    //this.$edEventBus.$on(COURSE_EVENTS.CARD_CREATED, this.loadingPage);
  }

  beforeDestroy() {
    this.$edEventBus.$off(COURSE_EVENTS.CHANGE_CARD_SIDE, this.resetCards);
    //this.$edEventBus.$off(COURSE_EVENTS.CARD_CREATED, this.loadingPage);
  }

  @Watch('section', { deep: true, immediate: false })
  subDeckChanged() {
    this.shuffleCards()
  }

  onCardChanged(data) {
    if(this.isPresentationTeacherMode) {
      this.$edEventBus.$emit(COURSE_EVENTS.CHANGE_CARD, data);
      this.$Courses.Store.setCurrentCardInfo(data);
    }
  }

  private resetCards(data) {

    if(this.cards?.length == 0 || ((Array.isArray(this.cards) && this.cards.length > 0) && this.cards[0].id != data.card.id)) {
      this.cards = []
      this.cards.push(data.card);
    }
  }

}
